export * from './notifications';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/services/notifications/index.js
// module id = 236
// module chunks = 0